"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";
import React from "react";
import Translations from "@translate/components/Chat/Cards/ReportHeader";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

const ReportHeader: React.FC<{ className?: string }> = (props) => {
  return (
    <div className={props?.className}>
      <span className="text-content_brand_primary body_medium_l">
        360{" "}
        <Icon
          name="edgen"
          size={12}
          color={ospThemes.colors.content_brand_primary}
          className="-ml-1"
        />
      </span>
      <span
        style={{
          color: ospThemes.colors.content_brand_primary,
        }}
      >
        {I18n.t("Report")}
      </span>
    </div>
  );
};

export default ReportHeader;
